import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import { openPopup } from "../../reducers/popup";
import Button from "../Button/Button";
import ModalHeader from "./ModalHeader";
import { getFullDateString } from "../../services/popup";

const ModalNoTurnVote = () => {
  const dispatch = useDispatch();
  const campaignStartAt = useSelector((state) => state?.user?.campaignStartAt) || process.env.REACT_APP_CAMPAIGN_START_AT;
  const campaignEndAt = useSelector((state) => state?.user?.campaignEndAt) || process.env.REACT_APP_CAMPAIGN_END_AT;

  const profile = useSelector((state) => state?.user?.profile || {});

  const handleCloseModal = () => {
    dispatch(openPopup());
  };
  const handleRegisterVip = () => {
    window.open("https://vieon.vn/mua-goi/", "_blank");
  };

  return (
    <Modal onClose={handleCloseModal}>
      <div className="z-20 bg-[#000] max-h-[95vh] relative mx-[4vw]">
        <button
          className="absolute z-10 w-4 h-4 top-3 right-3"
          title="Close"
          onClick={handleCloseModal}
        >
          <svg
            className="w-4 h-auto"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8323 10.0156L19.6199 2.22773C20.1267 1.72117 20.1267 0.902117 19.6199 0.39555C19.1133 -0.111017 18.2943 -0.111017 17.7877 0.39555L9.99989 8.18339L2.21228 0.39555C1.70548 -0.111017 0.88667 -0.111017 0.380103 0.39555C-0.126701 0.902117 -0.126701 1.72117 0.380103 2.22773L8.16771 10.0156L0.380103 17.8034C-0.126701 18.31 -0.126701 19.129 0.380103 19.6356C0.632556 19.8883 0.964494 20.0152 1.29619 20.0152C1.62789 20.0152 1.95959 19.8883 2.21228 19.6356L9.99989 11.8478L17.7877 19.6356C18.0404 19.8883 18.3721 20.0152 18.7038 20.0152C19.0355 20.0152 19.3672 19.8883 19.6199 19.6356C20.1267 19.129 20.1267 18.31 19.6199 17.8034L11.8323 10.0156Z"
              fill="#fff"
            />
          </svg>
        </button>
        <div className="relative">
          <div className="container max-w-[600px] modal-bg p-4 px-[4vw] !min-h-[145vw] h-[145vw] ">
            <ModalHeader
              classNamesContainer="relative top-0"
              classNamesLogoRapViet="max-w-[500px] 2xl:max-w-[686px] mx-auto pt-4"
              classNamesLogoBrand="lg:-translate-y-20 max-w-[500px] 2xl:max-w-[686px] mx-auto pt-4 md:-translate-y-10 -translate-y-6"
            ></ModalHeader>

            <div className="flex flex-col items-center px-4 py-4 mx-auto text-white  form-bg">
              <h3 className="mb-4 text-xl font-bold text-center">
                Bạn đã hết lượt bình chọn
              </h3>
              <p className="leading-5 text-center">
                Hãy quay lại vào ngày mai để tiếp tục bình chọn{" "}
                <span>Chung kết Anh Trai Say Hi</span>
                <br />

                {!profile?.is_premium ?
                  <>Đăng ký VIP để có 5 lượt bình chọn mỗi ngày
                  </> : ""
                }
                <br />
                Thời gian bình chọn
                <br />
                Từ {getFullDateString(campaignStartAt)} {" "}
                đến {getFullDateString(campaignEndAt)}
              </p>
              <div className="z-30 flex w-full gap-4 mt-8">
                <Button
                  text="Quay lại sau"
                  type="outline"
                  onClickButton={handleCloseModal}
                  classNames="py-4 text-lg md:text-xl bg-transparent border-[0.7px] !border-[#0ee2ff]"
                ></Button>
                {!profile?.is_premium ? <Button
                  text="Đăng ký VIP"
                  type="linear"
                  onClickButton={handleRegisterVip}
                  classNames="border-[0.7px] !bg-[#008cd5] py-4 text-lg md:text-xl text-white"
                ></Button> : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalNoTurnVote;
